import {Title} from '@radix-ui/react-dialog';

import {Heading} from '../Heading';

type Props = React.ComponentPropsWithRef<typeof Heading>;
export const DialogTitle = (
  {
    ref: forwardedRef,
    children,
    ...props
  }: Props & {
    ref?: React.RefObject<HTMLHeadingElement>;
  }
) => (<Title asChild>
  <Heading {...props} ref={forwardedRef}>
    {children}
  </Heading>
</Title>);

DialogTitle.displayName = 'DialogTitle';
